<template>
  <div
    class="bg-white rounded-xl shadow-lg border border-gray-100 p-4 md:p-6 hover:shadow-xl transition-shadow duration-300">
    <div class="h-[350px] md:h-[300px]">
      <Bar :data="data" :options="options" />
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
} from "chart.js";
import { Bar } from "vue-chartjs";
import { computed, ref } from "vue";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Colors
);

export default {
  name: "TotalSalesForMonthReportGrapics",
  components: {
    Bar,
  },
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const normalizedDatas = computed(() => ({
      cheque: Number(props.datas?.cheque ?? 0),
      efectivo: Number(props.datas?.efectivo ?? 0),
      tarjeta: Number(props.datas?.tarjeta ?? 0),
      transferencia: Number(props.datas?.transferencia ?? 0),
    }));

    const data = computed(() => ({
      labels: ["Cheque", "Efectivo", "Tarjeta", "Transferencia"],
      datasets: [
        {
          label: "VENTAS DEL MES",
          data: [
            normalizedDatas.value.cheque,
            normalizedDatas.value.efectivo,
            normalizedDatas.value.tarjeta,
            normalizedDatas.value.transferencia,
          ],
          backgroundColor: [
            "rgba(139, 92, 246, 0.8)",
            "rgba(34, 197, 94, 0.8)",
            "rgba(251, 146, 60, 0.8)",
            "rgba(14, 165, 233, 0.8)",
          ],
          borderColor: [
            "rgba(139, 92, 246, 1)",
            "rgba(34, 197, 94, 1)",
            "rgba(251, 146, 60, 1)",
            "rgba(14, 165, 233, 1)",
          ],
          borderWidth: 2,
          borderRadius: 8,
        },
      ],
    }));

    const isMobile = () => window.innerWidth < 768;

    const options = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: !isMobile(),
          position: 'bottom',
          labels: {
            padding: isMobile() ? 10 : 15,
            font: {
              size: isMobile() ? 10 : 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 500,
            },
            color: '#4B5563',
            usePointStyle: true,
            pointStyle: 'circle',
          },
        },
        title: {
          display: true,
          text: "Ventas del Mes por Método de Pago",
          padding: {
            top: isMobile() ? 5 : 10,
            bottom: isMobile() ? 10 : 20,
          },
          font: {
            size: isMobile() ? 13 : 16,
            family: "'Inter', 'system-ui', sans-serif",
            weight: 700,
          },
          color: '#1F2937',
        },
        tooltip: {
          backgroundColor: 'rgba(17, 24, 39, 0.95)',
          padding: isMobile() ? 8 : 12,
          cornerRadius: 8,
          titleFont: {
            size: isMobile() ? 11 : 13,
            weight: 600,
          },
          bodyFont: {
            size: isMobile() ? 10 : 12,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          border: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            font: {
              size: isMobile() ? 10 : 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 500,
            },
            color: '#6B7280',
            padding: isMobile() ? 8 : 10,
          },
        },
        x: {
          border: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            font: {
              size: isMobile() ? 10 : 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 600,
            },
            color: '#1F2937',
            padding: isMobile() ? 8 : 10,
            maxRotation: 0,
            minRotation: 0,
          },
        },
      },
      barPercentage: 0.7,
      categoryPercentage: 0.8,
    });
    return {
      data,
      options,
    };
  },
};
</script>
